import { useMutation } from '@apollo/client'
import { ADD_TEST_LOCATION, } from './operations'
import { AddTestLocationVariables, AddTestLocation } from '../../types'

export const useAddTestLocation = () =>
    useMutation<AddTestLocation, AddTestLocationVariables>(ADD_TEST_LOCATION)

